import { useState } from 'react';
import { Link } from 'react-router';

import ClearableInput from '@rio-cloud/rio-uikit/ClearableInput';

const questionMarkIcon = 'https://uikit.developers.rio.cloud/static/icons/question-sign.svg';

export const IconCustomIcon = () => {
    const [customIcon, setCustomIcon] = useState('https://uikit.developers.rio.cloud/static/images/svg/react_logo.svg');

    const handleCustomIcon = (
        newValue: string,
        event: React.ChangeEvent<HTMLInputElement> | React.MouseEvent<HTMLSpanElement>
    ) => {
        setCustomIcon(newValue);
    };

    return <IconCustomIconPreview customIcon={customIcon} handleCustomIcon={handleCustomIcon} />;
};

const IconCustomIconPreview = ({
    customIcon,
    handleCustomIcon,
}: {
    customIcon: string;
    handleCustomIcon: (
        newValue: string,
        event: React.ChangeEvent<HTMLInputElement> | React.MouseEvent<HTMLSpanElement>
    ) => void;
}) => {
    return (
        <div>
            <p>
                Use external svgs as icons. Please read our <Link to='/start/guidelines/custom-icon'>guidelines</Link>
            </p>
            <div className='display-flex gap-10'>
                <div className='flex-1-1'>
                    <div className='input-group width-100pct'>
                        <span className='input-group-addon'>
                            <span
                                className='uikit-icon text-color-primary'
                                aria-hidden='true'
                                style={
                                    {
                                        '--i': `url(${customIcon || questionMarkIcon})`,
                                    } as React.CSSProperties
                                }
                            />
                        </span>
                        <ClearableInput value={customIcon} placeholder='Enter icon URL' onChange={handleCustomIcon} />
                    </div>
                </div>
            </div>
        </div>
    );
};
